export const firebaseConfig = {
  apiKey: 'AIzaSyBZPthVP0XyQ_4wy86gZUWNdsP7YMZkdOE',
  authDomain: 'arecreativa.firebaseapp.com',
  projectId: 'arecreativa',
  storageBucket: 'arecreativa.appspot.com',
  messagingSenderId: '112494766663',
  appId: '1:112494766663:web:7f914bc83b9dc7b9ab5f62',
  measurementId: 'G-E9WTDCL2NV'
};